import { Text, Textarea, Button } from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion, useAnimation } from 'framer-motion';
import { Store } from '../../store';
import { getIntroField } from '../../utils';
import { useFrame } from 'react-frame-component';
import { useMemoizedFrame } from '../../utils/hooks';
import posthog from 'posthog-js';
import { useIsDesktop } from '../../utils/dimensions';

type IntroMessageCollectionProps = {
  shouldHideSubmission?: boolean;
  additionalContext?: boolean;
  submitMessage: (message: string) => void;
};

export const IntroMessageCollection: React.FC<IntroMessageCollectionProps> = (props) => {
  const { submitMessage, shouldHideSubmission, additionalContext } = props;
  const [message, setMessage] = useState('');
  const labels = Store.useState((s) => s.labels);
  const control = useAnimation();
  const hideSubmission = getIntroField('introMessageToExpert') || shouldHideSubmission;
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const { document } = useMemoizedFrame();
  const isDesktop = useIsDesktop();
  useEffect(() => {
    if (textareaRef && textareaRef.current && document?.activeElement !== textareaRef.current && isDesktop) {
      setTimeout(() => textareaRef?.current?.focus(), 200);
    }
  }, [textareaRef]);
  return (
    <>
      <Text variant="paragraph-medium" id="intro-message-text">
        {additionalContext ? labels.doYouWantToAdd : labels.howCanTheExpertHelp}
      </Text>
      <AnimatePresence>
        {!hideSubmission && (
          <motion.div key={'introMessageSubmissionBox'} initial={{ marginTop: 12 }} animate={control}>
            <Textarea
              variant="in-chat-textarea"
              onChange={(e) => setMessage(e.target.value)}
              value={message}
              aria-multiline={true}
              autoFocus
              ref={textareaRef}
              aria-labelledby="intro-message-text"
            />
            <Button
              variant="submit-cta"
              mt="12px"
              isDisabled={!message.trim().length}
              onClick={() => {
                if (message) {
                  posthog.capture('SEND-EXPERT-INTRO-MESSAGE', {
                    message: message.trim()
                  });
                  submitMessage(message.trim());
                  control.start({
                    opacity: 0,
                    marginTop: 0,
                    transition: { duration: 0.2, delay: 0, ease: 'easeInOut' }
                  });
                  control.start({
                    height: 0,
                    transition: { duration: 0.2, delay: 0.3, ease: 'easeInOut' }
                  });
                  control.start({
                    display: 'none',
                    transition: { delay: 0.5, duration: 0.2, ease: 'easeInOut' }
                  });
                }
              }}
            >
              {labels.submitIntroMessage}
            </Button>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
